import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OptionsModalEnum } from 'src/app/common/options-modal';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyClosure } from 'src/app/models/company.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { FormTaxResponse } from 'src/app/models/tax.model';
import { CompanyService } from 'src/app/services/company.service';
import { TaxService } from 'src/app/services/tax.service';

@Component({
  selector: 'app-accounting-tax-forms',
  templateUrl: './accounting-tax-forms.component.html',
  styleUrls: ['./accounting-tax-forms.component.scss']
})
export class AccountingTaxFormsComponent implements OnInit {
  years: number[] = [];
  year: number = null;
  months: any[] = [];
  monthName = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  }
  lastClosingMonth = null;
  clousure: [FormTaxResponse[]] = null;
  formsView = null;
  performingMonth = null;
  optionsEnum = OptionsModalEnum;

  constructor(
    private toastService: ToastrService,
    private companyService: CompanyService,
    private taxService: TaxService
  ) {
    var todayYear = new Date().getFullYear();
    this.year = todayYear;
    for (let i = 2022; i <= todayYear; i++) {
      this.years.push(i);
    }
    this.getAvailableMonths();
  }

  getAvailableMonths() {
    this.months = [];
    var available = new Date().getMonth();
    for (var i = 0; i < 12; i++) {
      this.months.push({
        name: this.monthName[i + 1],
        number: i + 1,
        closureData: {},
        show: (i < available && this.year === new Date().getFullYear()) || this.year !== new Date().getFullYear(),
        closing: new ButtonLoading("btn-success", false, "Realizar Cierre", "fa-check-to-slot")
      });
    }
  }

  ngOnInit(): void {
    this.getClosuresData();
    this.getFormsTaxByYear();
  }

  getClosuresData() {
    this.companyService.getClosures(this.year).subscribe({
      next: (response: ResponseObject) => {
        var responseMonths = response.data as CompanyClosure[];
        responseMonths.forEach((m) => {
          if (m.closedYear == this.year) {
            this.months[m.closedMonth - 1].closureData = m;
          }
        });
        this.validateLastClosing();
      },
      error: (error) => {
        this.toastService.error("Error al obtener los cierres");
      }
    })
  }

  goForms(formIndex) {
    this.formsView = this.clousure[formIndex - 1];
  }

  cleanAndGet(){
    this.getClosuresData();
    this.getFormsTaxByYear();
    this.getAvailableMonths();
  }

  getFormsTaxByYear() {
    this.taxService.getFormsByYear(this.year).subscribe({
      next: (response: ResponseObject) => {
        this.clousure = response.data;
        this.clousure.forEach((c) => {
          c.forEach((tax) => {
            tax.paying = new ButtonLoading("btn-success", false, "Ya pague", "fa-circle-check");
            tax.downloading = new ButtonLoading("btn-info", false, (tax.status == 31 || tax.status == 40) ? 'Descargar' : 'SAT-200', 'fa-download');
          })
        });
      },
      error: (error) => {
        this.toastService.error("Error al obtener la informacion");
      }
    })
  }

  performClosing(month) {
    this.performingMonth = month;
  }

  closeModal(event) {
    if (event === this.optionsEnum.ACCEPT) {
      if (this.performingMonth.closing.loading) {
        return;
      }
      var month = this.performingMonth.number;
      this.performingMonth.closing.loading = true;
      this.performingMonth.closing.message = "Realizando cierre...";
      this.companyService.performClosing(month, this.year).subscribe({
        next: (response: ResponseObject) => {
          this.getClosuresData();
          this.getFormsTaxByYear();
          this.getAvailableMonths();
          this.performingMonth.closing.loading = false;
          this.performingMonth.closing.message = "Realizar Cierre";
          this.performingMonth = null;
          this.toastService.success("Se ha realizado el cierre con éxito.");
        },
        error: (error: HttpErrorResponse) => {
          this.performingMonth.closing.loading = false;
          this.performingMonth.closing.message = "Realizar Cierre";
          this.performingMonth = null;
          this.toastService.error("Error al realizar el cierre");
        }
      })
    } else {
      this.performingMonth.closing.loading = false;
      this.performingMonth = null;
    }
  }

  validateLastClosing() {
    this.companyService.validateLastClosing().subscribe({
      next: (response: ResponseObject) => {
        if (response.data.general) {
          this.lastClosingMonth = new Date(response.data.general).getMonth();
        }
      },
      error: (error) => {
        this.toastService.error("Error al obtener el ultimo cierre");
      }
    })
  }

}
